
export default function CTAFinal() {
  return (
    <>
      <section className="py-24 bg-gradient-to-br from-purple-900 via-purple-800 to-purple-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img
            src="https://public.readdy.ai/ai/img_res/6f9a727625c038c01cd382776b728a52.jpg"
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Sua transformação começa agora
          </h2>
          
          <p className="text-xl md:text-2xl text-purple-100 mb-10 leading-relaxed">
            A pergunta não é se você pode crescer. A pergunta é: quando você vai começar?
          </p>
          
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-10 max-w-2xl mx-auto">
            <p className="text-lg text-white leading-relaxed mb-6">
              Pense onde você estará daqui a 6 meses se continuar fazendo do mesmo jeito. Agora imagine onde você pode estar se decidir investir em você hoje.
            </p>
            <p className="text-yellow-400 font-bold text-xl">
              O momento de agir é agora.
            </p>
          </div>
          
          <a
            href="https://pay.kiwify.com.br/gZuAA7n"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-yellow-400 text-purple-900 px-12 py-6 rounded-full text-xl font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 shadow-2xl cursor-pointer inline-flex items-center gap-3 mb-8 whitespace-nowrap"
          >
            Sim, quero transformar meu negócio
            <i className="ri-arrow-right-line text-2xl"></i>
          </a>
          
          <div className="flex flex-wrap items-center justify-center gap-6 text-purple-100">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-yellow-400 text-xl"></i>
              <span className="text-sm">Garantia de 7 dias</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-lock-line text-yellow-400 text-xl"></i>
              <span className="text-sm">Compra 100% segura</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-yellow-400 text-xl"></i>
              <span className="text-sm">Acesso imediato</span>
            </div>
          </div>
        </div>
      </section>
      
      <footer className="bg-purple-950 py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-3">
              <img
                src="https://static.readdy.ai/image/008029c4ca3238c7034e5a4be60d5bae/333b54039a066b237152bb16508c2149.jpeg"
                alt="Logo"
                className="h-10 w-auto object-contain"
              />
            </div>
            
            <div className="flex flex-wrap items-center justify-center gap-6 text-purple-300 text-sm">
              <a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
                Política de Privacidade
              </a>
              <a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
                Termos de Uso
              </a>
              <a href="#" className="hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap">
                Contato
              </a>
            </div>
            
            <div className="flex items-center gap-4">
              <a href="#" className="w-10 h-10 bg-purple-800 rounded-full flex items-center justify-center hover:bg-yellow-400 transition-all cursor-pointer">
                <i className="ri-instagram-line text-white text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-purple-800 rounded-full flex items-center justify-center hover:bg-yellow-400 transition-all cursor-pointer">
                <i className="ri-facebook-fill text-white text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-purple-800 rounded-full flex items-center justify-center hover:bg-yellow-400 transition-all cursor-pointer">
                <i className="ri-youtube-fill text-white text-xl"></i>
              </a>
            </div>
          </div>
          
          <div className="mt-8 pt-8 border-t border-purple-800 text-center">
            <p className="text-purple-400 text-sm">
              © 2025 Curso Online. Todos os direitos reservados. •{' '}
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-yellow-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
